import { notification, Button, Space } from 'antd';
import React, { useEffect } from 'react'

export const ActionLogNotification = ({handleCardOverviewSelection}) => {
    const [api, contextHolder] = notification.useNotification();
    const btn = (
        <Space>
          <Button type="primary" onClick={() => {handleCardOverviewSelection(); api.destroy()}}>
            Card Overview
          </Button>
        </Space>
    );

    const openNotification = () => {
        api.open({
            message: "Don't forget to close the card!",
            description:
            'Click the button below to go to the Card Overview section where you can close the card. Please ensure that you have selected an observation category for the card as you will not be able to close the card without one.',
            btn,
            duration: 0,
        });
    };

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            openNotification();
        }

        return () => mounted = false;
    }, [])

    return (
        <>
            {contextHolder}
        </>
    )
}
